import { sessionStorageGet, sessionStorageSet } from './index'

const TOUR_PAGE_PARAM = 'TOUR_PAGE_PARAM'
const TOUR_FROM_VIEW = 'TOUR_FROM_VIEW'
const TOUR_SCOPE_PARAM = 'TOUR_SCOPE_PARAM'
const PAGE_SCOPE_LANGUAGE = 'PAGE_SCOPE_LANGUAGE'

const RELATE_MENUS = 'RELATE_MENUS'
const LAST_OPERATE_TIME = 'LAST_OPERATE_TIME'
const TIMEOUT_NUM = 'TIMEOUT_NUM'
const MYSTERY_CODE = 'MYSTERY_CODE'
const CODE_EXTENDCOLUMN = 'CODE_EXTENDCOLUMN'
const ADD_CART_FROM_ACTIVITY = 'ADD_CART_FROM_ACTIVITY'
const SHUTTLE_BUS_INFO = 'SHUTTLE_BUS_INFO'
const HEAD_STORE_INFO = 'HEAD_STORE_INFO'

/*******
 * 保存班车信息
 */
export function setShuttleBusInfo(data){
    sessionStorageSet(SHUTTLE_BUS_INFO,data)
}
export function getShuttleBusInfo(data){
    return sessionStorageGet(SHUTTLE_BUS_INFO,data)
}
//设置页面参数
export function setPageParamSession(data){
    sessionStorageSet(TOUR_PAGE_PARAM,data)
}
//获取页面参数
export function getPageParamSession(data){
    return sessionStorageGet(TOUR_PAGE_PARAM,data)
}
//设置来源页面
export function setFromView(data){
    sessionStorageSet(TOUR_FROM_VIEW,data)
}
//获取来源页面
export function getFromView(data){
    return sessionStorageGet(TOUR_FROM_VIEW,data)
}

//全局条件
export function setScopeParam(data){
    sessionStorageSet(TOUR_SCOPE_PARAM,data)
}
//全局条件
export function getScopeParam(data){
    return sessionStorageGet(TOUR_SCOPE_PARAM,data)
}
//设置页面语言
export function setPageScopeLanguage(data){
    sessionStorageSet(PAGE_SCOPE_LANGUAGE,data)
}
//获取页面语言
export function getPageScopeLanguage(data){
    return sessionStorageGet(PAGE_SCOPE_LANGUAGE,data)
}

//设置关联菜单
export function setRelateMenusSession(data){
    sessionStorageSet(RELATE_MENUS,data)
}
//获取关联菜单
export function getRelateMenusSession(data){
    return sessionStorageGet(RELATE_MENUS,data)
}

//设置最后操作时间
export function setLastOperateTime(data){
    sessionStorageSet(LAST_OPERATE_TIME,data)
}
//获取最后操作时间
export function getLastOperateTime(data){
    return sessionStorageGet(LAST_OPERATE_TIME,data)
}

//设置超时时长
export function setTimeoutNum(data){
    sessionStorageSet(TIMEOUT_NUM,data)
}
//获取超时次数
export function getTimeoutNum(data){
    return sessionStorageGet(TIMEOUT_NUM,data)
}

//设置神秘码
export function setMysteryCode(data){
    sessionStorageSet(MYSTERY_CODE,data)
}
//获取神秘码
export function getMysteryCode(data){
    return sessionStorageGet(MYSTERY_CODE,data)
}

//设置扩展列
export function setCodeExtendColumn(data){
    sessionStorageSet(CODE_EXTENDCOLUMN,data)
}
//获取扩展列
export function getCodeExtendColumn(data){
    return sessionStorageGet(CODE_EXTENDCOLUMN,data)
}

/*******
 * 保存添加购物车来源
 */
export function setAddCartFromActivity(data) {
    sessionStorageSet(ADD_CART_FROM_ACTIVITY, data)
}
export function getAddCartFromActivity() {
    return sessionStorageGet(ADD_CART_FROM_ACTIVITY)
}

//设置总店信息
export function setHeadStoreInfoSession(data){
    sessionStorageSet(HEAD_STORE_INFO,data)
}
//获取总店信息
export function getHeadStoreInfoSession(data){
    return sessionStorageGet(HEAD_STORE_INFO,data)
}


